<!--产品介绍-->
<template>
  <div class="moduleThree">
    <slot></slot>
    <el-carousel type="card" :interval="5000" height="400px">
      <el-carousel-item
        v-for="(item, index) in mod3.productDtos"
        :key="index"
        :class="item.productUrl ? sty[0] : sty[1]"
      >
        <div style="display: flex;height: 100%" @click="jump(item.productUrl)">
          <div
            style="position: relative;width: 75%;height: 100%"
            v-if="
              item.productLogo ||
                item.productName ||
                item.productIntroduction ||
                item.productCode
            "
          >
            <div
              style="height: 60px;width: 230px;padding: 40px 0 15px 0;font-size: 20px;color: white;"
            >
              <div
                v-if="item.productName || item.productLogo"
                style="width: 100%;background: #ce7044;padding: 5px 0 5px 15px;border-radius: 0 30px 30px 0;display:flex;align-items: center;box-shadow: 5px 5px 5px #888888;"
              >
                <div v-html="item.productName"></div>
                <div style="width: 46px;height: 46px;padding-left: 10px">
                  <img
                    :src="item.productLogo"
                    style="width: 100%;height: 100%"
                  />
                </div>
              </div>
            </div>
            <div style="display: flex;text-align: center;height: 66.6%">
              <div
                v-if="item.productIntroduction"
                style="width: 100%;padding: 0 20px 0 50px"
                v-html="item.productIntroduction"
              ></div>
              <!-- <div v-if="item.productCode" style="width: 50%;margin: auto">
                <img :src="item.productCode" style="width: 100%" />
              </div> 二维码-->
            </div>
          </div>
          <div v-if="item.productImg" style="width: 80%;height: 100%">
            <div
              style="display: flex;align-items: center;height: 100%"
              v-if="
                item.productLogo ||
                  item.productName ||
                  item.productIntroduction ||
                  item.productCode
              "
            >
              <img :src="item.productImg" style="width: 100%;height: auto" />
            </div>
            <div
              style="height: 100%;text-align: center"
              v-if="
                !(
                  item.productLogo ||
                  item.productName ||
                  item.productIntroduction ||
                  item.productCode
                )
              "
            >
              <img :src="item.productImg" style="height: 100%" />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: ["mod3"],
  data() {
    return {
      styleObject: {
        height: ""
      },
      sty: ["hand", "cursor"]
    };
  },
  mounted() {
    this.innerHeight();
  },
  methods: {
    innerHeight() {
      this.styleObject.height = window.innerHeight / 2 + "px";
    },
    jump(productUrl) {
      let temp = productUrl.slice(0, 7);
      if (temp === "http://") {
        window.location.href = productUrl;
      } else {
        window.location.href = "http://" + productUrl;
      }
    }
  }
};
</script>

<style lang="sass">
.moduleThree
  white-space: normal
  word-break: break-all;overflow:hidden
  padding-bottom: 45px
  .el-carousel__item
    color: #475669
    font-size: 16px
    opacity: 0.96
    margin: 0
    text-align: conter
    &.is-active
      width: 800px
      margin-left: -100px
  .el-carousel__mask
    opacity: 0.75
  .el-carousel__item, .el-carousel__mask
    box-shadow: 5px 3px 10px #999
  .el-carousel__item:nth-child(2n)
    background-color: #eceef0
  .el-carousel__item:nth-child(2n+1)
    background-color: #eceef0
  .hand
    cursor: pointer
  .cursor
    cursor: default
</style>
